import classNames from 'classnames'
import { ReactElement } from 'react'

interface UnreadBadgeProps {
  variant?: `default` | `text`
  value?: number
  label?: string
  isSelected?: boolean
}

export function UnreadBadge({ value, label, variant, isSelected }: UnreadBadgeProps): ReactElement {
  if (!label && (value == null || value <= 0)) return <></>

  const text = label ?? (value! < 100 ? `${value} Unread` : `99+ Unread`)

  if (variant === `text`) {
    return <>{`[${text}]`}</>
  }

  return (
    <div
      className={classNames(
        `flex h-5 shrink-0 items-center rounded border-[0.5px] border-tags-orange_minimal/8 bg-tags-orange_minimal/8 px-1.5 text-center text-label-xs text-orange-800`,
      )}
    >
      <span className="text-label-xs font-medium">{text}</span>
    </div>
  )
}
